import PropTypes from 'prop-types';
// @mui
import {
  Box,
  Card,
  FormControlLabel,
  Switch,
  Table,
  TableBody,
  TableContainer,
  TablePagination
} from '@mui/material';
import useTable, { getComparator, emptyRows } from '../../../hooks/useTable';
// components
import Scrollbar from '../../Scrollbar';
import { TableEmptyRows, TableHeadCustom, TableNoData } from '../../../fl-components/table';
// sections
import AttendanceRow from './AttendanceTableRow';

const TABLE_HEAD = [
  { id: 'createdAt', label: 'Date', align: 'left' },
  { id: 'slotTiming', label: 'Slot Timing', align: 'left' },
  { id: 'present', label: 'Present', align: 'left' },
  { id: 'absent', label: 'Absent', align: 'left' },
  { id: '' }
];

// ----------------------------------------------------------------------

export default function AttendanceTable({ list, onEditHandle }) {
  const {
    dense,
    page,
    order,
    orderBy,
    rowsPerPage,
    //
    selected,
    onSelectRow,
    //
    onSort,
    onChangeDense,
    onChangePage,
    onChangeRowsPerPage
  } = useTable();

  const dataFiltered = applySortFilter({
    tableData: list,
    comparator: getComparator(order, orderBy)
    // filterName
  });

  const denseHeight = dense ? 52 : 72;

  const isNotFound = !dataFiltered.length;

  return (
    <Card>
      {/* <AttendanceToolbar onFilterName={handleFilterName} /> */}

      <Scrollbar>
        <TableContainer sx={{ minWidth: 800, position: 'relative' }}>
          <Table size={dense ? 'small' : 'medium'}>
            <TableHeadCustom
              order={order}
              orderBy={orderBy}
              headLabel={TABLE_HEAD}
              rowCount={list.length}
              numSelected={selected.length}
              onSort={onSort}
            />

            <TableBody>
              {dataFiltered
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => (
                  <AttendanceRow
                    key={row.id}
                    row={row}
                    selected={selected.includes(row.id)}
                    onSelectRow={() => onSelectRow(row.id)}
                    onEditRow={() => onEditHandle(row)}
                  />
                ))}

              <TableEmptyRows
                height={denseHeight}
                emptyRows={emptyRows(page, rowsPerPage, list.length)}
              />

              <TableNoData isNotFound={isNotFound} />
            </TableBody>
          </Table>
        </TableContainer>
      </Scrollbar>

      <Box sx={{ position: 'relative' }}>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={dataFiltered.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onChangePage}
          onRowsPerPageChange={onChangeRowsPerPage}
        />

        <FormControlLabel
          control={<Switch checked={dense} onChange={onChangeDense} />}
          label="Dense"
          sx={{ px: 3, py: 1.5, top: 0, position: { md: 'absolute' } }}
        />
      </Box>
    </Card>
  );
}

// ----------------------------------------------------------------------

function applySortFilter({ tableData, comparator }) {
  const stabilizedThis = tableData.map((el, index) => [el, index]);

  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  tableData = stabilizedThis.map((el) => el[0]);
  return tableData;
}

AttendanceTable.propTypes = {
  list: PropTypes.arrayOf(PropTypes.object),
  onEditHandle: PropTypes.func
};
